// ============================================
// B1（2026-10-03）：3D 编辑器弹窗配置（推广后台可管）
// 数据链：marketing-admin（站点配置 dtwin_popup_3d）→ marketing-api → dtwin-server 代理 →
//         web GET /api/v1/marketing/popup-config（拉取失败用内置默认值兜底）
// ============================================
import client from './client';

export interface PopupNoticeConfig {
  enabled?: boolean;
  title?: string;
  content?: string;
  /** 关闭按钮倒计时秒数（默认 10） */
  countdownSeconds?: number;
  dismissLabel?: string;
  closeLabel?: string;
  /** 自动弹出频率（小时；0/缺省=每次进入都弹） */
  frequencyHours?: number;
  servicePhone?: string;
  serviceHours?: string;
  wechatQrUrl?: string;
}

export interface PopupPackageOverride {
  displayName?: string;
  /** 划线原价（展示用） */
  originalPrice?: number;
  badge?: string;
  featured?: boolean;
  /** 追加展示权益（如限时赠送） */
  extraBenefits?: string[];
}

export interface PopupUpgradeConfig {
  enabled?: boolean;
  title?: string;
  subtitle?: string;
  bannerUrl?: string;
  /** 顶部提示条文案 */
  bannerText?: string;
  /** 自动弹出频率（小时；默认 1） */
  frequencyHours?: number;
  recommendPackageType?: string;
  /** 限时优惠等促销文案 */
  promoText?: string;
  /** 参与弹窗的套餐类型白名单（默认 saas/private；排除边缘硬件等套餐） */
  packageTypes?: string[];
  packageOverrides?: Record<string, PopupPackageOverride>;
}

export interface Popup3dConfig {
  notice?: PopupNoticeConfig;
  upgrade?: PopupUpgradeConfig;
}

export const DEFAULT_POPUP_CONFIG: Popup3dConfig = {
  notice: {
    enabled: true,
    title: '温馨提示',
    content: '您正在使用免费版 DTwince 进行三维场景搭建，为了给您提供更好的服务，请通过微信/电话客服进行咨询。',
    countdownSeconds: 16,
    dismissLabel: '不再提示',
    closeLabel: '关闭',
    frequencyHours: 0,
    servicePhone: '',
    serviceHours: '周一至周五 9:00-18:00',
    wechatQrUrl: '',
  },
  upgrade: {
    enabled: true,
    title: '会员套餐订阅',
    subtitle: '解锁完整 3D 与 GIS 能力，去除画面水印',
    bannerUrl: '',
    bannerText: '免费版 · 升级套餐去水印',
    frequencyHours: 1,
    recommendPackageType: 'pro',
    promoText: '',
    packageTypes: ['saas', 'private'],
    packageOverrides: {},
  },
};

function mergeConfig(v: Popup3dConfig | null | undefined): Popup3dConfig {
  if (!v || typeof v !== 'object') return DEFAULT_POPUP_CONFIG;
  return {
    notice: { ...DEFAULT_POPUP_CONFIG.notice, ...(v.notice ?? {}) },
    upgrade: {
      ...DEFAULT_POPUP_CONFIG.upgrade,
      ...(v.upgrade ?? {}),
      packageOverrides: { ...(v.upgrade?.packageOverrides ?? {}) },
    },
  };
}

export async function fetchPopupConfig(): Promise<Popup3dConfig> {
  try {
    const r = await client.get('/marketing/popup-config');
    return mergeConfig(r.data?.value ?? null);
  } catch {
    return DEFAULT_POPUP_CONFIG;
  }
}
